export const STPRECOPRATICADO_PRECO_OPCAO = 0;
export const STPRECOPRATICADO_MENOR_PRECO = 1;
export const STPRECOPRATICADO_PRECO_MEDIO = 2;
export const STPRECOPRATICADO_MAIOR_PRECO = 3;
export const STPRECOPRATICADO_DESPREZA_PRECO = 4;
export const STPRECOPRATICADO_KIT = 10;
